import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
} from '@angular/material/dialog';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import { FormsModule } from '@angular/forms';
import { ButtonComponent } from '../../../shared/components/button/button.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'qa-copy-link-dialog',
  templateUrl: './copy-link-dialog.component.html',
  styleUrls: ['./copy-link-dialog.component.scss'],
  imports: [
    MatRadioGroup,
    FormsModule,
    MatRadioButton,
    MatDialogActions,
    ButtonComponent,
    MatDialogClose,
    TranslateModule,
  ],
})
export class CopyLinkDialogComponent {
  createCopy: string = 'link';

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}
}
